import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Shaping = () => {
  return (
    <section className="relative py-32 px-6 flex flex-col items-center justify-center overflow-hidden bg-[#020810]">
      {/* Background Decor */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-r from-blue-900/20 via-gold/5 to-purple-900/20 blur-[120px] rounded-full" />
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mb-12"
        >
          <span className="section-badge mb-8">Mission & Vision</span>
          <h2 
            className="text-4xl md:text-7xl font-black text-white mb-8 leading-tight tracking-tight"
            style={{ fontFamily: "Orbitron, sans-serif" }}
          >
            Shaping <span className="text-gold">Bright Minds</span> <br />
            for a Brighter Future
          </h2>
          <div className="w-32 h-2 bg-gold mx-auto rounded-full mb-12 shadow-[0_0_20px_rgba(244,200,66,0.5)]" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-12 text-left"
        >
          <div className="p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md">
            <h3 className="text-gold font-bold uppercase tracking-widest text-sm mb-4">Our Vision</h3>
            <p className="text-gray-300 text-lg leading-relaxed font-medium">
              To be a global leader in education, where every student is a star nurtured to illuminate 
              the world through wisdom, character, and innovative thinking.
            </p>
          </div>
          <div className="p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md">
            <h3 className="text-gold font-bold uppercase tracking-widest text-sm mb-4">Our Mission</h3>
            <p className="text-gray-300 text-lg leading-relaxed font-medium">
              To provide a safe, inclusive, and inspiring environment that empowers students 
              to excel academically and grow into compassionate, responsible global citizens.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16"
        >
          <Link
            to="/enroll"
            className="cosmic-btn-gold px-12 py-5 rounded-full text-sm font-black uppercase tracking-[0.2em]"
          >
            Become a Galaxy Star Student
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Shaping;
